import { styled } from '@mui/material/styles';
import { Container, Grid } from '@mui/material';
import Page from '../components/Page';
import { useAtomValue } from 'jotai';
import { myAtom } from 'src/pages/Home';
import Maintenance from 'src/pages/Maintenance';
import { ResourcesHero, ResourcesList } from '../sections/resources';

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(8),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(11),
  },
}));

export default function Resources() {
    const isUnderMaintenance = useAtomValue(myAtom);

    return (
      <Page title="Contact Us">
        <RootStyle>
          {' '}
          {isUnderMaintenance && <Maintenance />}
          {!isUnderMaintenance && (
            <>
              <ResourcesHero />
              <Container sx={{ mt: 15, mb: 10}}><ResourcesList /></Container>
              
            </>
          )}
        </RootStyle>
      </Page>
    );
  }
  